const globalObject = globalThis as unknown as Record<string, unknown>;

if (typeof globalObject.queueMicrotask === 'undefined') {
  globalObject.queueMicrotask = (callback: () => void): Promise<void> => Promise.resolve().then(callback);
}
